/* eslint id-length: "off", no-magic-numbers: "off" */
const SECONDS_PER_MINUTE = 60;
const MS_PER_SECOND = 1000;

export const fmtDuration = (ms = 0) => {
  if (!ms || ms < 0) {
    return "0:00";
  }
  const totalSeconds = Math.floor(ms / MS_PER_SECOND);
  const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
  const seconds = totalSeconds % SECONDS_PER_MINUTE;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
};

export const fmtSeconds = (sec = 0) => fmtDuration(sec * MS_PER_SECOND);

// Builds the album line, e.g. "#3 on Album (1994)".
// Falls back gracefully when the track number or year is missing.
export const albumLine = track => {
  if (!track.albumName) {
    return "";
  }
  const prefix = track.trackNumber ? `#${track.trackNumber} on ` : "";
  const suffix = track.releaseYear ? ` (${track.releaseYear})` : "";
  return `${prefix}${track.albumName}${suffix}`;
};
